import React, { useState } from 'react';

const CommentForm = ({ onSubmit, isSubmitting }) => {
    const [formData, setFormData] = useState({
        author_name: '',
        author_email: '',
        content: '',
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.author_name.trim()) {
            newErrors.author_name = 'Name is required';
        }

        if (!formData.author_email.trim()) {
            newErrors.author_email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.author_email)) {
            newErrors.author_email = 'Email is invalid';
        }

        if (!formData.content.trim()) {
            newErrors.content = 'Comment is required';
        } else if (formData.content.trim().length < 10) {
            newErrors.content = 'Comment must be at least 10 characters';
        } else if (formData.content.trim().length > 2000) {
            newErrors.content = 'Comment must not exceed 2000 characters';
        }

        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        onSubmit(formData);

        // Reset form
        setFormData({
            author_name: '',
            author_email: '',
            content: '',
        });
        setErrors({});
    };

    return (
        <form onSubmit={handleSubmit} className="mt-8 border-t border-gray-200 pt-8">
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#31415A' }}>
                Leave a Comment
            </h3>

            <div className="grid md:grid-cols-2 gap-4 mb-4">
                {/* Name Field */}
                <div>
                    <label htmlFor="author_name" className="block text-sm font-medium mb-2" style={{ color: '#31415A' }}>
                        Name *
                    </label>
                    <input
                        type="text"
                        id="author_name"
                        name="author_name"
                        value={formData.author_name}
                        onChange={handleChange}
                        className={`w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 ${errors.author_name ? 'border-red-500' : 'border-gray-300'
                            }`}
                        style={{ '--tw-ring-color': '#C9A14F' }}
                        placeholder="Your name"
                        disabled={isSubmitting}
                    />
                    {errors.author_name && (
                        <p className="text-red-500 text-sm mt-1">{errors.author_name}</p>
                    )}
                </div>

                {/* Email Field */}
                <div>
                    <label htmlFor="author_email" className="block text-sm font-medium mb-2" style={{ color: '#31415A' }}>
                        Email *
                    </label>
                    <input
                        type="email"
                        id="author_email"
                        name="author_email"
                        value={formData.author_email}
                        onChange={handleChange}
                        className={`w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 ${errors.author_email ? 'border-red-500' : 'border-gray-300'
                            }`}
                        style={{ '--tw-ring-color': '#C9A14F' }}
                        placeholder="your@email.com"
                        disabled={isSubmitting}
                    />
                    {errors.author_email && (
                        <p className="text-red-500 text-sm mt-1">{errors.author_email}</p>
                    )}
                </div>
            </div>

            {/* Comment Field */}
            <div className="mb-4">
                <label htmlFor="content" className="block text-sm font-medium mb-2" style={{ color: '#31415A' }}>
                    Comment *
                </label>
                <textarea
                    id="content"
                    name="content"
                    value={formData.content}
                    onChange={handleChange}
                    className={`w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 ${errors.content ? 'border-red-500' : 'border-gray-300'
                        }`}
                    style={{ '--tw-ring-color': '#C9A14F' }}
                    rows="5"
                    placeholder="Share your thoughts..."
                    disabled={isSubmitting}
                />
                <div className="flex justify-between items-start mt-1">
                    {errors.content && (
                        <p className="text-red-500 text-sm">{errors.content}</p>
                    )}
                    <p className="text-sm text-gray-500 ml-auto">
                        {formData.content.length} / 2000
                    </p>
                </div>
            </div>

            {/* Info Message */}
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
                <p className="text-sm text-blue-800">
                    ℹ️ Your comment will be reviewed before publishing
                </p>
            </div>

            {/* Submit Button */}
            <button
                type="submit"
                disabled={isSubmitting}
                className="px-8 py-3 rounded text-white font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                style={{ backgroundColor: '#C9A14F' }}
            >
                {isSubmitting ? 'Submitting...' : 'Submit Comment'}
            </button>
        </form>
    );
};

export default CommentForm;
